import React from 'react';
import { Handle, NodeProps, Position } from '@xyflow/react';

import { nodeStylesConfig as styles } from './nodeStylesConfig';
import { ExpandCollapseNode } from './types';

export const CustomNode: React.FC<NodeProps<ExpandCollapseNode>> = ({
  data,
  id,
}) => {
  return (
    <div
      id={id}
      style={{
        backgroundColor: styles[id]?.bgColor || '',
        color: styles[id]?.textColor || '',
        borderColor: styles[id]?.borderColor || '',
        borderWidth: styles[id]?.borderColor ? '1px' : '0px',
        padding: `${styles[id]?.padding || '0'}px`,
        width: `${styles[id]?.width}px` || '100%',
        textAlign: 'center',
        lineHeight: '12px',
        borderRadius: `${styles[id]?.borderRadius || '0'}px`,
      }}
    >
      <div style={{ fontSize: `${styles[id]?.fontSize || '10'}px` }}>
        {data.label}
      </div>
      <Handle type="target" position={Position.Top} className=" opacity-0" />
      <Handle type="source" position={Position.Bottom} className=" opacity-0" />
    </div>
  );
};
